import { useAppSelector } from 'flow/hooks/useRedux';
import { twMerge } from 'tailwind-merge';
import { ChatUserKey, ExtensionKey } from 'flow/types/EntityKeys';
import { isTypeExtensionKey } from 'flow/utils/extension-utils-TW';
import { useModal } from 'flow/contexts/ModalProvider';

interface Props {
    name: string;
    userKey: ChatUserKey | ExtensionKey;
}

const InternalNoteMention = ({ name, userKey }: Props) => {
    const { openModal } = useModal();

    const keyIsExtensionKey = isTypeExtensionKey(userKey);

    const extensionKey = useAppSelector((state) =>
        keyIsExtensionKey
            ? userKey
            : state.chats?.getIn(['extensions', userKey]),
    );

    const handleClick = extensionKey
        ? () => openModal('contactModal', { extensionKey: extensionKey })
        : null;

    return (
        <button
            type="button"
            className={twMerge(
                'text-link',
                !handleClick ? 'cursor-default' : '',
            )}
            onClick={handleClick}
        >
            {name}
        </button>
    );
};

export default InternalNoteMention;
